// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KFLS","title":"Info_title__24UNV","selects":"Info_selects__1XJLe","requiredAsterisk":"Info_requiredAsterisk__2WeUu"};